<template>
  <FullBackdrop>
    <div 
      class="container"
      v-click-outside="close"
    >
      <div class="close-btn" @click="close">
        <div>
          X
        </div>
      </div>

      <div class="profilePic-container" @click="selectImage">
        <div class="floating front">
          <img v-if="imageUrl" :src="imageUrl" />
        </div>
        <div class="floating back">
          <i class="fas fa-user" ></i>
        </div>
        <div class="blackout">
          <span>
            {{ $t('dashboard.change_profilepic.title') }}
          </span>
        </div>
        <input
          type="file"
          accept="image/*"
          autocomplete="attached_files"
          id="profilePic"
          ref="files"
          @change="changeImage"
          @touchcancel="selectingFile = false"
        />
      </div>

      <!-- <div class="send-btn" @click="sendImage">
        {{ $t('change_profilepic.button') }}
      </div> -->

      <div v-if="text" class="text" :class="{error: error}">
        {{ text }}
      </div>
    </div>
  </FullBackdrop>
</template>

<script>
import FontAwesome from "../../../public/js/lib/FontAwesomeKit"; // <--- importing FontAwesome icons
import FullBackdrop from "../FullBackdrop.vue";

export default {
  components: {
    FullBackdrop,
  },
  data() {
    return {
      image: null,
      selectingFile: false,
      text: "",
      error: false,
      timeout: null,
    };
  },
  methods: {
    selectImage() {
      if (this.selectingFile) return;
      this.selectingFile = true;
      this.$refs.files.click();
    },
    changeImage(event) {
      this.selectingFile = false;
      this.image = event.target.files[0];
    },
    // sendImage() {
    //   this.text = this.$t('change_profilepic.waiting');

    //   resources.user.changeProfilePicture({ file: this.image })
    //     .then((response) => {
    //       this.$emit('updateProfilePic', this.imageUrl);
    //       this.$emit('close');
    //     })
    //     .catch((error) => {
    //       this.error = true;
    //       this.text = this.$t('change_profilepic.error');

    //       this.timeout = setTimeout(() => {
    //         this.error = false;
    //         this.text = "";
    //       }, 3000);
    //     });
    // },
    close() {
      if (this.selectingFile) return;
      this.$emit('close');
    },
    checkSelectingFile() {
      this.selectingFile = !!this.image;
    }
  },
  mounted() {
    this.selectImage();

    window.addEventListener('focus', this.checkSelectingFile, true);
  },
  computed: {
    imageUrl() {
      if (this.image) {
        return URL.createObjectURL(this.image);
      }
      return null;
    }
  },
  beforeDestroy() {
    if (this.timeout) clearTimeout(this.timeout);
    window.removeEventListener('focus', this.checkSelectingFile, true);
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";
@import "../../styles/classes";

.container {
  position: relative;
}

.profilePic-container {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: #fff;
  margin: 0 auto;
  margin-bottom: 20px;
  border: 1px solid var(--pallete_dark_text_color);
  display: flex;

  .floating {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    &.front {
      z-index: 10;
    }

    &.back {
      z-index: 5;
    }
  }

  i {
    margin: auto;
    font-size: 100px;
    // color: var(--pallete_main_color);
    color: var(--pallete_dark_text_color);
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  cursor: pointer;
  position: relative;

  .blackout {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: rgba(0,0,0,0.5);
    display: none;
    z-index: 99;

    span {
      color: var(--pallete_clear_color);
      text-align: center;
      vertical-align: middle;
      margin: auto;
    
      &::selection {
        background-color: transparent;
      }
    }
  }

  &:hover {
    .blackout {
      display: flex;
    }
  }
}

#profilePic {
  visibility: hidden;
}

.send-btn {
  @extend %fresh-btn;
}

.close-btn {
  @extend %fresh-btn;
  position: absolute;
  top: 0;
  right: 0;
  padding: 0px;
  cursor: pointer;

  $SIZE: 35px;
  border-radius: 40%;
  height: $SIZE;
  width: $SIZE;
  display: flex;

  > div {
    margin: auto;
    font-size: 20px;
  }
}

.text {
  margin-top: 2em;
  text-align: center;

  &.error {
    color: var(--pallete_error_color);
  }
}

</style>
